// extracted by mini-css-extract-plugin
export var drawerPaper = "_27-0";
export var itemImage = "_27-1";